class FileUtils {
    ANEXO_SIZE_LIMIT = 50 // em MB;

    EXTENSOES_VALIDAS = ['bmp', 'doc', 'dot', 'jpg', 'pdf', 'png', 'xls', 'odt', 'odf', 'rtf', 'txt', 'xml', 'html', 'gif', 'zip', 'rar', 'xlsx', 'docx', 'ppt', 'pptx', '7z', 'jpeg', 'htm', 'csv', 'qrp', 'tdm', 'ofx', 'ofc'];

    EXTENSOES_VISUALIZAVEIS = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'txt', 'bmp'];

    constructor() {}

    /** 
     * Migrar para a de baixo e remover esta futuramente
     * @deprecated
    */
    converterBlobParaBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };

    async converterArquivoParaBase64(arquivo) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(arquivo);
        });
      };

      _splitNomeExtensao(nomeCompleto) {
        const nomeArray = nomeCompleto.split('.');
        const extensao = nomeArray.pop().toLowerCase();
        const nome = nomeArray.join('.');
        return [nome, extensao];
      };

      _converteMbParabyte(tamanho) {
        const tamanhoAsInt = parseInt(tamanho);
        return tamanhoAsInt * 1024 * 1024;
      };

      _convertebyteParaMb(tamanho) {
        const tamanhoAsInt = parseInt(tamanho);
        return tamanhoAsInt / 1024 / 1024;
      }

      _isExtensaoValida(extensao, extensoesValidas = this.EXTENSOES_VALIDAS) {
        return extensoesValidas.includes(extensao)
      }

      isExtensaoVisualizavelNoNavegador(extensao) {
        return this.EXTENSOES_VISUALIZAVEIS.includes(extensao?.toLowerCase())
      }

      downloadArquivo(url, nomeArquivo) {
        const link = document.createElement('a');
        link.href = url;
        link.download = nomeArquivo;
        link.click();
      }

      visualizarArquivo(url) {
        window.open(url, '_blank');
      }
}

export const fileUtils = new FileUtils();